'use client';

import { AuthProvider } from '../contexts/AuthContext';
import PageTransition from '@/components/common/PageTransition';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <PageTransition>{children}</PageTransition>
    </AuthProvider>
  );
}